import { useConfig as hook } from '@eika-infrastruktur/config-provider';
import nbTranslations from './translations/nbTranslations-config';
import nnTranslations from './translations/nnTranslations-config';
export const APP_NAMESPACE = 'marked.cookie-consent';
export const COOKIE_CONSENT_SET_KEY = 'eika_consent_set';
export const defaultConfig = {
    siteLang: 'nb',
    translations: {
        nb: nbTranslations,
        nn: nnTranslations,
    },
};
function createHook() {
    return () => hook();
}
export const useConfig = createHook();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmYXVsdC1jb25maWcuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvZGVmYXVsdC1jb25maWcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFNBQVMsSUFBSSxJQUFJLEVBQWMsTUFBTSxxQ0FBcUMsQ0FBQztBQUVwRixPQUFPLGNBQWMsTUFBTSxzQ0FBc0MsQ0FBQztBQUNsRSxPQUFPLGNBQWMsTUFBTSxzQ0FBc0MsQ0FBQztBQUdsRSxNQUFNLENBQUMsTUFBTSxhQUFhLEdBQUcsdUJBQXVCLENBQUM7QUFFckQsTUFBTSxDQUFDLE1BQU0sc0JBQXNCLEdBQUcsa0JBQWtCLENBQUM7QUFrQnpELE1BQU0sQ0FBQyxNQUFNLGFBQWEsR0FBVztJQUNqQyxRQUFRLEVBQUUsSUFBYTtJQUN2QixZQUFZLEVBQUU7UUFDVixFQUFFLEVBQUUsY0FBYztRQUNsQixFQUFFLEVBQUUsY0FBYztLQUNyQjtDQUNKLENBQUM7QUFFRixTQUFTLFVBQVU7SUFDZixPQUFPLEdBQUcsRUFBRSxDQUFDLElBQUksRUFBSyxDQUFDO0FBQzNCLENBQUM7QUFDRCxNQUFNLENBQUMsTUFBTSxTQUFTLEdBQUcsVUFBVSxFQUF3QixDQUFDIn0=